import React from "react";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const LinkRouter = (props: any) => <Link {...props} component={RouterLink} />;

interface IBreadcrumbsComponentProps {
	children?: React.ReactNode;
}
export const BreadcrumbsComponent: React.FC<IBreadcrumbsComponentProps> = (props) => {
	const items = window.location.pathname.split("/");

	return (
		<MuiBreadcrumbs aria-label="breadcrumb" >
			{items.map((item, index) => {
				const isLastItem = index === items.length - 1;

				return isLastItem ? (
					<Typography color="textPrimary" key={item}>
						{item}
					</Typography>
				) : (
					<LinkRouter color="inherit" to={`/${item}`} key={item}>
						{item}
					</LinkRouter>
				);
			})}
			{props.children}
		</MuiBreadcrumbs>
	);
};

